/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ClickToChat = defineMessages({
  title: {
    id: 'whatsapp.ClickToChat.title',
    defaultMessage: 'WhatsApp click to chat'
  },
  subtitle: {
    id: 'whatsapp.ClickToChat.subtitle',
    defaultMessage:
      "Below, provide your WhatsApp related phone number and a useful message for starting the conversation. This will appear automatically in the customer's text field. <link>Learn more</link>"
  },
  phoneNumberLabel: {
    id: 'whatsapp.ClickToChat.phoneNumberLabel',
    defaultMessage: 'Company phone number (optional)'
  },
  phoneNumberPlaceholder: {
    id: 'whatsapp.ClickToChat.phoneNumberPlaceholder',
    defaultMessage: '555-555-5555'
  },
  phoneNumberError: {
    id: 'whatsapp.ClickToChat.phoneNumberError',
    defaultMessage:
      'Phone numbers can only contain number characters (0-9) and plus(+), minus(-) and parenthesis.'
  },
  phoneNumberEmptyError: {
    id: 'whatsapp.ClickToChat.phoneNumberError',
    defaultMessage: 'Phone number cannot be empty.'
  },
  messageLabel: {
    id: 'whatsapp.ClickToChat.messageLabel',
    defaultMessage: 'Pre-filled message (Optional)'
  },
  defaultChatMessage: {
    id: 'whatsapp.ClickToChat.defaultChatMessage',
    defaultMessage: 'Hi, can you help me?'
  },
  messagePlaceholder: {
    id: 'whatsapp.ClickToChat.messagePlaceholder',
    defaultMessage: 'For example: Hi, I need help with an order.'
  },
  embedLinkTitle: {
    id: 'whatsapp.ClickToChat.embedLinkTitle',
    defaultMessage: 'Embed link'
  },
  embedLinkDescription: {
    id: 'whatsapp.ClickToChat.embedLinkDescription',
    defaultMessage:
      'Use the below snippet to embed your unique WhatsApp click to chat launcher on your desired browser pages.'
  },
  embedLinkLabel: {
    id: 'whatsapp.ClickToChat.embedLinkLabel',
    defaultMessage: 'Embed link'
  }
});
